import { useQuery } from '@tanstack/react-query';

import { getLanguage, globalConst } from '..';

export const useLanguage = () => {
  const { data, ...args } = useQuery({
    queryKey: [globalConst.queryKeys.GET_LANGUAGE],
    queryFn: getLanguage
  });

  return { ...data, ...args };
};
